export const columns = [
  {
    title: '项目名称',
    dataIndex: 'name',
    ellipsis: true,
  },
  {
    title: '业主',
    dataIndex: 'proprietor',
    ellipsis: true,
  },
  {
    title: '开标日期',
    dataIndex: 'bidder_timef',
    ellipsis: true,
    width: 140,
  },
  {
    title: '担保额度',
    dataIndex: 'money',
    ellipsis: true,
    width: 120,
  },
  {
    title: '操作',
    dataIndex: 'id',
    scopedSlots: { customRender: 'action' },
    width: 100,
  },
];
